/** Unicode characters for the Rooster TipTap emoji toolbar picker (inserts plain text / emoji). */
export const ROOSTER_EMOJI_PICKER_CHARS = [
    '😀', '😃', '😄', '😁', '😅', '😂', '🤣', '🥲', '☺️', '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '😋', '😛', '😜', '🤪', '😝', '🤑', '🤗', '🤭', '🤫', '🤔',
    '😐', '😑', '😶', '😏', '😒', '🙄', '😬', '🤥', '😔', '😪', '🤤', '😴', '😷', '🤒', '🤕', '🤢', '🤮', '🥵', '🥶', '🥴', '😵', '🤯', '🤠', '🥳', '😎', '🤓', '🧐',
    '👍', '👎', '👌', '✌️', '🤞', '🤟', '🤘', '🙌', '👏', '🙏', '💪', '🤝', '👋', '🤚', '✋', '🖐️', '👆', '👇', '👈', '👉',
    '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '💔', '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝',
    '🔥', '✨', '⭐', '🌟', '💫', '⚡', '☀️', '🌈', '☁️', '❄️', '💧', '☂️',
    '✅', '❌', '⚠️', '❓', '❗', '💬', '📌', '📎', '📝', '✉️', '📧', '📞', '📱',
    '🎉', '🎁', '🏆', '🥇', '🎯', '⏰', '📅', '📍', '🔔', '🔒', '🔓', '🔑',
];
